/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VignettePriceList } from '../../models/vignette-price-list';

export interface GetVignettePriceLists$Params {
}

export function getVignettePriceLists(http: HttpClient, rootUrl: string, params?: GetVignettePriceLists$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VignettePriceList>>> {
  const rb = new RequestBuilder(rootUrl, getVignettePriceLists.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VignettePriceList>>;
    })
  );
}

getVignettePriceLists.PATH = '/price-list';
